import { createClient } from '@supabase/supabase-js';

// In a real application, these should be environment variables.
// For this demo, you would need to set these in your deployment or .env file.
// We provide fallback values to prevent the application from crashing immediately if keys are missing.
// We check for Vite first, then fallback to CRA, then fallback to placeholder
export const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co';
export const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder-key';

if (supabaseUrl === 'https://placeholder.supabase.co') {
    console.warn("Supabase URL or Key is missing. Database features will not work.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
